import React, { Suspense } from 'react'
import { Routes, Route } from 'react-router-dom'
import type { IRoute } from './router/config'
import { layoutRouteList } from './router/utils'
import Logo from '@src/components/logo'
import '@mantine/core/styles.css'
const App: React.FC = (): React.ReactElement => {
  return (
    <Suspense fallback={<Logo />}>
      <Routes>
        {layoutRouteList.map((route: IRoute) => (
          <Route key={route.path} path={route.path} element={<route.component />} />
        ))}
      </Routes>
    </Suspense>
  )
}

export default App
